<script>
	import Ribbon from '../../../components/v0/Lobby/Ribbon.svelte';
	import LobbyButton from '../../../components/v0/Lobby/LobbyButton.svelte';
	import PrimaryButton from '../../../components/v0/Buttons/PrimaryButton.svelte';
	import Vector from '../../../assets/vector.svelte';
	import ProfileAvatar from '../../../components/v0/Lobby/ProfileAvatar.svelte';
	import Container from '../../../components/v0/Container/Container.svelte';
	import SurpriseImg from '../../../assets/surprise_img.svelte';
	export let isHost = false;
	export let onlineUsers = [];
	export let offlineUsers = [];
	export let handleStartGame = () => {};
	export let onMouseDown = () => {};
	export let bottomText = '';
	export let hostId = [];
	export let hostName = '';
	let showJoined = true;
	$: {
		if (onlineUsers.length > 0) {
			let hostArray = onlineUsers.filter((user) => hostId.includes(user.id));
			if (hostArray.length > 0) {
				onlineUsers = onlineUsers.filter((el) => !hostId.includes(el.id));
				onlineUsers = [...hostArray, ...onlineUsers];
			}
		}
	}
</script>

<div class="lobbyOuterWrapper">
	<Container padding="0" borderRadius="21">
		<div class="lightShow">
			<Vector />
		</div>
		<div class="lobbyWrapper">
			<div class="lobbyRibbon">
				<Ribbon width="136" height="35" fontSize="18" text="Lobby" />
			</div>

			<div class="joinedAndNotJoined">
				<div class="joined" on:click={() => (showJoined = true)} on:mousedown={onMouseDown}>
					<LobbyButton
						height="34"
						fontSize="16"
						text={`Joined (${onlineUsers.length}) `.toUpperCase()}
						isJoined={true}
						disabled={!showJoined}
					/>
				</div>
				<div class="notJoined" on:click={() => (showJoined = false)} on:mousedown={onMouseDown}>
					<LobbyButton
						height="34"
						fontSize="16"
						text={`Waiting For (${offlineUsers.length}) `.toUpperCase()}
						isJoined={false}
						disabled={showJoined}
					/>
				</div>
			</div>

			<div class="users">
				<div class="userInnerContainer">
					{#if showJoined}
						<!-- add id here -->
						{#if onlineUsers.length > 0}
							{#each onlineUsers as user (user.id)}
								<div>
									<ProfileAvatar
										src={user.profilePicture}
										userName={user.userName}
										size="60"
										fontSize="18"
										isHost={hostId.includes(user.id)}
									/>
								</div>
							{/each}
						{/if}
					{:else if offlineUsers.length > 0}
						{#each offlineUsers as user (user.id)}
							<div>
								<ProfileAvatar
									src={user.profilePicture}
									userName={user.userName}
									size="60"
									fontSize="18"
									isHost={hostId.includes(user.id)}
								/>
							</div>
						{/each}
					{/if}
				</div>
			</div>
			{#if isHost}
				<div class="startGame">
					<PrimaryButton
						width="135"
						height="45"
						text="Start Game"
						fontSize="18"
						disabled={false}
						onClick={handleStartGame}
						{onMouseDown}
					/>
				</div>
			{:else}
				<p class="waitingForHostText">
					{#if hostId.length === 1}
						{`Waiting for ${hostName}(Host) to start the game`}
					{:else}
						Waiting for any of the Hosts to start the game
					{/if}
				</p>
			{/if}
		</div>
	</Container>
</div>
<div class="containerWrapper">
	<Container padding="12" borderRadius="12">
		<div class="bottomContainer">
			<div class="surpriseContainer">
				<SurpriseImg />
			</div>
			<div class="bottomText">
				{bottomText.toUpperCase()}
			</div>
		</div>
	</Container>
</div>

<style>
	.lobbyOuterWrapper {
		position: relative;
		width: 100%;
		margin: auto;
		margin-top: 2rem;
		max-width: 532px;
		padding: 0 1rem;
	}
	.lightShow {
		position: absolute;
		height: 218px;
		width: 635px;
		left: 50%;
		transform: translate(-50%);
		top: -45%;
	}
	.lobbyWrapper {
		position: relative;
		width: 100%;
		height: 300px;
		margin: auto;
		display: flex;
		flex-direction: column;
		color: black;
	}

	.lobbyRibbon {
		position: absolute;
		top: -15px;
		left: 50%;
		transform: translate(-50%);
	}

	.joinedAndNotJoined {
		display: flex;
		margin-top: 2rem;
		padding: 0 24px;
		justify-content: center;
		align-items: flex-start;
	}

	.joined,
	.notJoined {
		flex: 1;
	}

	.notJoined {
		margin-left: 1rem;
	}

	.users {
		flex: 1;
		margin-bottom: 2.4rem;
		padding: 0 18px;
		margin-top: 10px;
		width: 100%;
		height: calc(100% - 120px);
	}
	.userInnerContainer {
		height: 100%;
		background: #f7f6f7;
		border-radius: 14px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		flex-direction: row;
		width: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		row-gap: 1rem;
		padding-top: 0.9rem;
		padding-bottom: 0.9rem;
	}
	.userInnerContainer div {
		flex: 0 1 20%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.startGame {
		position: absolute;
		bottom: -20px;
		left: 50%;
		transform: translate(-50%);
	}
	.bottomContainer {
		max-width: 381px;
		margin: auto;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.surpriseContainer {
		width: 52px;
	}
	.bottomText {
		margin-left: 1rem;
		text-align: center;
		font-size: 14px;
		line-height: 14px;
		color: rgba(106, 117, 118, 1);
	}
	.containerWrapper {
		margin: auto;
		margin-top: 2rem;
		max-width: 532px;
		padding: 0 1rem;
	}
	.waitingForHostText {
		font-size: 14px;
		text-align: center;
		margin-bottom: 1rem;
		position: absolute;
		bottom: -5px;
		left: 50%;
		transform: translate(-50%);
		width: 100%;
		padding: 0 12px;
		color: rgba(106, 117, 118, 1);
	}
	::-webkit-scrollbar {
		width: 8px;
		height: 122px;
	}
	::-webkit-scrollbar-thumb {
		background: #6c44a8;
		border-radius: 15px;
	}
	::-webkit-scrollbar-track {
		background: transparent;
		margin-left: 10px;
	}

	::-webkit-scrollbar-track-piece:end {
		background: transparent;
		margin-bottom: 10px;
	}

	::-webkit-scrollbar-track-piece:start {
		background: transparent;
		margin-top: 10px;
	}
	@media only screen and (max-height: 550px) {
		.lobbyWrapper {
			height: 250px;
		}
		.containerWrapper {
			margin-top: 2rem;
		}
	}
</style>
